import React from "react";
import { FiInfo } from "react-icons/fi";
import { ProgressBar } from "react-loader-spinner";
import CriteriaTable from "./CriteriaTable";

const stages = [
    { value: 1, label: "۱ — مراجعه‌کننده" },
    { value: 2, label: "۲ — علاقه‌مند به محصول" },
    { value: 3, label: "۳ — علاقه‌مند به خرید" },
    { value: 4, label: "۴ — مشتری" },
    { value: 5, label: "۵ — مشتری وفادار" },
    { value: 6, label: "۶ — مشتری ناراضی" },
];

const CriteriaListSection = ({
    criteriaData,
    criteriaLoading,
    criteriaError,
    getApiStatus,
    getTypeBadge,
    getStatusBadge,
    onEdit,
    onToggleVisibility,
    onDeactivate,
    onReactivate,
    onDelete,
}) => {
    return (
        <div className="overflow-hidden rounded-2xl border border-teal-100 bg-white shadow-sm">
            <div className="border-b border-teal-50 bg-gradient-to-l from-teal-50/70 to-white px-5 py-4 sm:px-6">
                <h2 className="text-lg font-bold text-[#173B3A]">
                    لیست معیارها — بر اساس دسته
                </h2>
                <p className="mt-1 text-xs text-gray-500">
                    معیارهای تعریف‌شده برای هر مرحله از قیف
                </p>
            </div>

            <div className="p-5 sm:p-6">
                {criteriaLoading ? (
                    <div className="flex items-center justify-center py-10">
                        <ProgressBar visible={true} height="60" width="60" color="#0F766E" />
                    </div>
                ) : criteriaError ? (
                    <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                        {criteriaError}
                    </div>
                ) : (
                    <>
                        {stages.map((stage) => (
                            <CriteriaTable
                                key={stage.value}
                                title={stage.label}
                                items={criteriaData
                                    .filter((item) => Number(item.stageOrder) === stage.value)
                                    .map((item) => ({
                                        ...item,
                                        status: getApiStatus(item),
                                        usage: item.usage || {
                                            templateUsageCount: 0,
                                            personalizedFunnelUsageCount: 0,
                                            totalUsageCount: 0,
                                        },
                                    }))}
                                getTypeBadge={getTypeBadge}
                                getStatusBadge={getStatusBadge}
                                onEdit={onEdit}
                                onToggleVisibility={onToggleVisibility}
                                onDeactivate={onDeactivate}
                                onReactivate={onReactivate}
                                onDelete={onDelete}
                            />
                        ))}
                    </>
                )}

                {/* Guide */}
                <div className="mt-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm leading-7 text-gray-700">
                    <div className="mb-2 flex items-center gap-2 font-bold text-amber-800">
                        <FiInfo />
                        راهنمای وضعیت‌ها
                    </div>
                    <div>
                        <span className="font-medium text-teal-700">فعال / نمایان</span>
                        : قابل انتخاب برای Preset و Business جدید.
                    </div>
                    <div>
                        <span className="font-medium text-amber-700">مخفی‌شده</span>
                        : استفاده‌ی فعلی همچنان معتبر است، ولی برای انتخاب‌های جدید نمایش داده نمی‌شود.
                    </div>
                    <div>
                        <span className="font-medium text-gray-600">غیرفعال</span>
                        : فقط وقتی ممکن است که هیچ Preset/Business فعالی از این معیار استفاده نکند.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CriteriaListSection;